import { React } from 'react';
import styled from 'styled-components';

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import FetchModule from '../../../../Share/Network/FetchModule';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';

export default function MemberShipExtendDeleteModal(props) {
  const { data, onClickExit } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();

  function deleteClick() {
    var requestData = {
      extendId: data.extendId
    }

		const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('membership/extends/delete', 'POST', requestData);

        if (responseData.status === 200) {
          onClickExit();
        }
      }
    )();
  }

  return (
    <TotalModalWrapper>
      <ModalView $isDark={isDark}>
        <Title>{t('memberDetail.extendDeleteTitle')}</Title>
        <TextWrapper>
          <Explanation>{t('memberDetail.extendDeleteDesc1')}</Explanation>
          <Explanation>{t('memberDetail.extendDeleteDesc2')}</Explanation>
        </TextWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickExit}>{t('memberDetail.modalCancel')}</ExitButton>
          <CancelButton onClick={deleteClick}>{t('memberDetail.modalProceed')}</CancelButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}


const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 371px;
  height: 248px;

  border-radius: 30px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 16px 28px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 28px;

  gap: 14px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  gap: 16px;

  margin: 53px 0 0 153px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 38px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 15px;
  background-color: ${props => props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.text};
      color: ${props => props.theme.text};
    }
  }
`;

const CancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: #FF3131;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;
